import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "approveMgDetail-content" }
const _hoisted_2 = { class: "approveMgDetail-head" }
const _hoisted_3 = { class: "approveMgDetail-head-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "姓名：", -1)
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "approveMgDetail-head-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "工号：", -1)
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "approveMgDetail-head-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "手机号：", -1)
const _hoisted_11 = { class: "right" }
const _hoisted_12 = { class: "approveMgDetail-head-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "部门：", -1)
const _hoisted_14 = { class: "right" }
const _hoisted_15 = { class: "approveMgDetail-head-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "公司：", -1)
const _hoisted_17 = { class: "right" }
const _hoisted_18 = {
  key: 0,
  style: {"color":"#f56c6c"}
}
const _hoisted_19 = {
  key: 1,
  style: {"color":"#67c23a"}
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_double_left_outlined = _resolveComponent("double-left-outlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_app_operates = _resolveComponent("app-operates")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_action_modal = _resolveComponent("action-modal")!
  const _component_a_card = _resolveComponent("a-card")!
  const _directive_call = _resolveDirective("call")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer approveMgDetail" }, {
    title: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_double_left_outlined, {
          class: "back",
          onClick: _ctx.goBack
        }, null, 8, ["onClick"]),
        _createElementVNode("span", null, "审批单号：" + _toDisplayString(_ctx.recordData.approvalNo), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_app_operates, { mg: "0 0 20px" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.recordData.userName || '---'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.recordData.jobNumber || '---'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.recordData.phone ? `${_ctx.recordData.phone.substr(0,3)}****${_ctx.recordData.phone.substr(7)}` : '---'), 1)
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.recordData.deptName || '---'), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.recordData.enterpriseName || '---'), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "id",
          "show-pagination": true,
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          scroll: { x:'100%', y: 500 }
        }, {
          tagException: _withCtx(({ record }) => [
            (record.tagException)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(record.tagException), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_19, "正常"))
          ]),
          originName: _withCtx(({ record }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, "起点：" + _toDisplayString(record.originName), 1),
              _createElementVNode("div", null, "终点：" + _toDisplayString(record.destinationName), 1)
            ])
          ]),
          action: _withCtx(({ record }) => [
            (record.approveStatus === 0 && record.status === 2 && record.showApprovalFlag)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#",
                  onClick: ($event: any) => (_ctx.handleOperate('approve', record.id ))
                }, "审批", 8, _hoisted_20))
              : _createCommentVNode("", true),
            (!(record.approveStatus === 0 && record.status === 2))
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "#",
                  onClick: ($event: any) => (_ctx.handleOperate('view', record.id ))
                }, [
                  _createTextVNode("详情")
                ], 8, _hoisted_21)), [
                  [
                    _directive_call,
                    { action: 'view', id: record.id },
                    void 0,
                    { doWith: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ]),
      _createVNode(_component_action_modal, {
        ref: "actionModalRef",
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["onComplete"])
    ]),
    _: 1
  }))
}